import { injectToolCSS } from "../utils/cssGenerator";
import { t } from "../i18n/translate";
import visitIcon from "../icons/visitIcon";
import toggle from "../views/menu/toggleMenu";
import { HEADER_SELECTORS, LANDMARK_SELECTORS, LINKS_SELECTORS } from "../enum/Selectors";
import { scrollToElement } from "../utils/dom";

export const pageStructureConfig = {
    id: 'page-structure',
    enable: false,
    css: `
        .asw-structure-modal {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 90%;
            max-width: 700px;
            height: 85vh;
            background: rgba(255, 255, 255, 0.9);
            backdrop-filter: blur(20px);
            z-index: 1000001;
            box-shadow: 0 20px 50px rgba(0,0,0,0.2);
            border-radius: 24px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            font-family: inherit;
            color: #1a1a1a;
            border: 1px solid rgba(255,255,255,0.3);
        }
        .asw-structure-header {
            padding: 15px 20px;
            background: linear-gradient(135deg, #0848ca 0%, #002D80 100%);
            color: #fff;
            display: flex;
            justify-content: space-between;
            align-items: center; 
        }
        .asw-structure-title {
            font-weight: 700;
            font-size: 22px;
            letter-spacing: -0.02em;
        }
        .asw-structure-close {
            cursor: pointer;
            font-size: 32px;
            line-height: 1;
            opacity: 0.8;
            transition: opacity 0.2s;
            background: transparent;
            border: none;
            color: inherit;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .asw-structure-close:hover {
            opacity: 1;
        }
        .asw-structure-close > svg {
            fill: white !important;
            width: 24px;
            height: 24px;
        }
        .asw-structure-content {
            padding: 0;
            overflow: hidden;
            flex: 1;
            display: flex;
            flex-direction: column;
        }
        .asw-tabs-nav {
            display: flex;
            background: #f8f9fa;
            border-bottom: 1px solid rgba(0,0,0,0.05);
            padding: 0 20px 0;
            gap: 5px;
        }
        .asw-tab-btn {
            padding: 12px 20px;
            border: none;
            background: transparent;
            font-size: 14px;
            font-weight: 600;
            color: #666;
            cursor: pointer;
            border-radius: 12px 12px 0 0;
            transition: all 0.2s;
            position: relative;
        }
        .asw-tab-btn:hover {
            color: #0848ca;
            background: rgba(8, 72, 202, 0.05);
        }
        .asw-tab-btn.asw-active {
            color: #0848ca;
            background: #fff;
            box-shadow: 0 -2px 10px rgba(0,0,0,0.02);
        }
        .asw-tab-btn.asw-active::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            height: 2px;
            background: #0848ca;
        }
        .asw-tab-panels {
            flex: 1;
            overflow-y: auto;
            padding: 10px 20px 30px;
        }
        .asw-tab-content {
            display: block;
        }
        .asw-tab-content.asw-hidden {
            display: none;
        }
        .asw-structure-section {
            margin-bottom: 0;
        }
        .asw-structure-nested-wrapper {
            margin-left: 24px;
            border-left: 2px solid rgba(8, 72, 202, 0.2);
            padding-left: 12px;
            margin-top: -4px;
            margin-bottom: 4px;
            transition: border-color 0.3s ease;
        }
        .asw-structure-nested-wrapper:hover {
            border-left-color: rgba(8, 72, 202, 0.4);
        }
        .asw-structure-item {
            padding: 12px 16px;
            margin: 8px 0;
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            align-items: center;
            gap: 12px;
            outline: none;
            background: #fff;
            box-shadow: 0 2px 8px rgba(0,0,0,0.02);
            border: 1px solid rgba(0,0,0,0.05);
            width: 100%;
            text-align: left;
            box-sizing: border-box;
            position: relative;
        }
        .asw-structure-item:hover, .asw-structure-item:focus-within {
            background: #f0f7ff;
            border-color: rgba(8, 72, 202, 0.2);
            box-shadow: 0 4px 12px rgba(8, 72, 202, 0.08);
        }
        .asw-structure-tag {
            font-size: 10px;
            background: #f1f3f5;
            padding: 2px 6px;
            border-radius: 5px;
            color: #495057;
            font-weight: 700;
            text-transform: uppercase;
            min-width: 24px;
            text-align: center;
        }
        .asw-structure-text {
            font-size: 15px;
            font-weight: 500;
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #333;
        }
        .asw-structure-actions {
            display: flex;
            gap: 8px;
            opacity: 0.4;
            transition: opacity 0.2s;
        }
        .asw-structure-item:hover .asw-structure-actions {
            opacity: 1;
        }
        .asw-action-btn {
            background: transparent;
            border: none;
            padding: 4px;
            cursor: pointer;
            border-radius: 6px;
            color: #666;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
        }
        .asw-action-btn:hover {
            background: rgba(8, 72, 202, 0.1);
            color: #0848ca;
        }
        .asw-structure-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 15, 60, 0.3);
            backdrop-filter: blur(8px);
            z-index: 1000000;
        }
    `
};

export default function pageStructure(enable = false) {
    injectToolCSS({
        ...pageStructureConfig,
        enable
    });

    const overlay = document.createElement('div');
    overlay.className = 'asw-structure-overlay';

    const modal = document.createElement('div');
    modal.className = 'asw-structure-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'asw-structure-title');

    const header = document.createElement('div');
    header.className = 'asw-structure-header';
    header.innerHTML = `
        <div id="asw-structure-title" class="asw-structure-title">${t('Page Structure')}</div>
        <button class="asw-structure-close" aria-label="${t('Close')}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d ="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"/>
            </svg>
        </button>
    `;

    const content = document.createElement('div');
    content.className = 'asw-structure-content';

    const tabsNav = document.createElement('div');
    tabsNav.className = 'asw-tabs-nav';
    tabsNav.setAttribute('role', 'tablist');

    const panelsContainer = document.createElement('div');
    panelsContainer.className = 'asw-tab-panels';

    const sections: { id: string, name: string, element: HTMLElement }[] = [];

    // Scan for Headings (Hierarchical)
    const headings = Array.from(document.querySelectorAll(HEADER_SELECTORS.join(', ')));
    if (headings.length > 0) {
        const section = createSection();
        let lastLevel = 1;
        let currentParent = section;
        const parentStack: HTMLElement[] = [section];

        headings.forEach(h => {
            const level = parseInt(h.nodeName.substring(1)) || 1;

            if (level > lastLevel) {
                const wrapper = document.createElement('div');
                wrapper.className = 'asw-structure-nested-wrapper';
                currentParent.appendChild(wrapper);
                parentStack.push(wrapper);
                currentParent = wrapper;
            } else {
                while (level < lastLevel && parentStack.length > 1) {
                    parentStack.pop();
                    currentParent = parentStack[parentStack.length - 1];
                    lastLevel--;
                }
            }

            const tag = h.nodeName.startsWith('H') ? h.nodeName : 'HDR';
            currentParent.appendChild(createItem(tag, h.textContent || 'Untitled', () => scrollToElement(h as HTMLElement)));
            lastLevel = level;
        });
        sections.push({ id: 'headings', name: t('Headings'), element: section });
    }

    // Scan for Landmarks
    const landmarks = Array.from(document.querySelectorAll(LANDMARK_SELECTORS.join(', ')));
    if (landmarks.length > 0) {
        const section = createSection();
        landmarks.forEach(l => {
            const label = l.getAttribute('aria-label') || l.nodeName.toLowerCase();
            section.appendChild(createItem('AREA', label, () => scrollToElement(l as HTMLElement)));
        });
        sections.push({ id: 'landmarks', name: t('Landmarks'), element: section });
    }

    // Scan for Links
    const links = Array.from(document.querySelectorAll(LINKS_SELECTORS.join(', '))).filter(a => a.textContent?.trim());
    if (links.length > 0) {
        const section = createSection();
        links.slice(0, 50).forEach(a => {
            section.appendChild(createItem('Link', a.textContent || 'Link', () => scrollToElement(a as HTMLElement), (a as HTMLAnchorElement).href));
        });
        sections.push({ id: 'links', name: t('Links'), element: section });
    }

    // Create Tabs and Panels
    sections.forEach((s, index) => {
        const btn = document.createElement('button');
        btn.id = `asw-tab-${s.id}`;
        btn.className = 'asw-tab-btn' + (index === 0 ? ' asw-active' : '');
        btn.textContent = s.name;
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        btn.setAttribute('aria-controls', `asw-panel-${s.id}`);

        const panel = document.createElement('div');
        panel.id = `asw-panel-${s.id}`;
        panel.className = 'asw-tab-content' + (index === 0 ? '' : ' asw-hidden');
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', btn.id);
        panel.appendChild(s.element);

        btn.addEventListener('click', () => {
            modal.querySelectorAll('.asw-tab-btn').forEach(b => {
                b.classList.remove('asw-active');
                b.setAttribute('aria-selected', 'false');
            });
            modal.querySelectorAll('.asw-tab-content').forEach(p => p.classList.add('asw-hidden'));

            btn.classList.add('asw-active');
            btn.setAttribute('aria-selected', 'true');
            panel.classList.remove('asw-hidden');
        });

        tabsNav.appendChild(btn);
        panelsContainer.appendChild(panel);
    });

    content.appendChild(tabsNav);
    content.appendChild(panelsContainer);

    modal.appendChild(header);
    modal.appendChild(content);

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    const closePageStructure = () => {
        modal.remove();
        overlay.remove();

        // Remove selected class from the page-structure button
        const menuContainer = document.querySelector('.asw-menu')?.parentElement;
        if (menuContainer) {
            const triggerBtn = menuContainer.querySelector('.asw-btn[data-key="page-structure"]');
            if (triggerBtn) {
                triggerBtn.classList.remove('asw-selected');
            }
        }
    };

    header.querySelector('.asw-structure-close')?.addEventListener('click', closePageStructure);
    overlay.addEventListener('click', closePageStructure);

    function createSection() {
        const div = document.createElement('div');
        div.className = 'asw-structure-section';
        return div;
    }

    function createItem(tag: string, text: string, onClick: () => void, visitUrl?: string) {
        const item = document.createElement('div');
        item.className = 'asw-structure-item';

        const content = document.createElement('div');
        content.style.display = 'flex';
        content.style.alignItems = 'center';
        content.style.gap = '12px';
        content.style.flex = '1';
        content.style.cursor = 'pointer';

        content.innerHTML = `
            <span class="asw-structure-tag">${tag}</span>
            <span class="asw-structure-text">${text}</span>
        `;

        const actions = document.createElement('div');
        actions.className = 'asw-structure-actions';

        if (visitUrl) {
            const vBtn = document.createElement('button');
            vBtn.className = 'asw-action-btn';
            vBtn.innerHTML = `
                <span>${t('Visit link')}</span>
                <span>${visitIcon}</span>
            `;
            vBtn.title = t('Visit link');
            vBtn.setAttribute('aria-label', t('Visit link'));
            vBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                window.open(visitUrl, '_blank');
            });
            actions.appendChild(vBtn);
        }

        item.appendChild(content);
        item.appendChild(actions);

        const handler = () => {
            onClick();
            
            closePageStructure();

            // Hide main menu
            const menuContainer = document.querySelector('.asw-menu')?.parentElement;
            if (menuContainer) {
                toggle(menuContainer as HTMLElement, false);
            }
        };

        content.addEventListener('click', handler);

        return item;
    }
}
